/* eslint-disable @typescript-eslint/no-explicit-any */
import { db } from "../config/firebaseConfig";
import {
  Firestore,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";

const ApiUtils = {
  getAddress: async function (value: any) {
    try {
      const response = await fetch(
        `https://ws.geonorge.no/adresser/v1/sok?sok=${value}`
      );
      return response;
    } catch (error: any) {
      throw error.response;
    }
  },

  getSingleAddress: async function (params: Record<string, any>) {
    try {
      const url = `https://ws.geonorge.no/adresser/v1/sok?sok=${`${params.adressenavn} ${params.nummer}`}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error: any) {
      console.error("Error fetching address:", error);
      throw error;
    }
  },
  handleLookup: async (phoneNumber: string) => {
    if (!phoneNumber) return;
    const cleanedNumber = phoneNumber.replace(/\D/g, "").replace(/^47/, "");
    try {
      const response = await fetch(
        `https://services.api1881.no/lookup/phonenumber/${cleanedNumber}`,
        {
          method: "GET",
          headers: {
            "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_OCP_APIM_KEY}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (err: any) {
      console.error(err);
    }
  },
};

export default ApiUtils;

export const fetchAdminDataByEmail = async () => {
  const id: string | null = localStorage.getItem("__Iplot_admin_access_");

  if (id) {
    try {
      const q = query(collection(db, "admin"), where("id", "==", id));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docRef = querySnapshot.docs[0];

        return docRef.data();
      } else {
        console.error("No document found for id:", id);
        return null;
      }
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
  }
};

export const fetchAdminRole = async (): Promise<any | null> => {
  const id: string | null = localStorage.getItem("__Iplot_admin_access_");
  if (id) {
    try {
      const q = query(collection(db, "admin"), where("id", "==", id));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        console.warn("No document found for id:", id);
        return null;
      }

      const docData = querySnapshot.docs[0].data();
      return docData?.role ?? null;
    } catch (error) {
      console.error("Error fetching admin data:", error);
      return null;
    }
  }
};

export const fetchLeadData = async (id: string) => {
  try {
    const supplierDocRef = doc(db, "leads_from_supplier", id);
    const docSnap = await getDoc(supplierDocRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.error("No document found for ID:", id);
    }
  } catch (error) {
    console.error("Error fetching lead data:", error);
  }
};
export const fetchOfficeData = async (id: string) => {
  try {
    const officeDocRef = doc(db, "office", id);
    const docSnap = await getDoc(officeDocRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.error("No document found for ID:", id);
    }
  } catch (error) {
    console.error("Error fetching office data:", error);
  }
};

export const fetchHusmodellData = async (id: string) => {
  try {
    if (id) {
      const husmodellDocRef = doc(db, "house_model", id);
      const docSnap = await getDoc(husmodellDocRef);

      if (docSnap.exists()) {
        return docSnap.data();
      }
    }
  } catch (error) {
    console.error("Error fetching husmodell data:", error);
  }
};

export const fetchInventoryData = async (id: string) => {
  try {
    if (id) {
      const inventoryDocRef = doc(db, "inventory", id);
      const docSnap = await getDoc(inventoryDocRef);

      if (docSnap.exists()) {
        return docSnap.data();
      }
    }
  } catch (error) {
    console.error("Error fetching inventory data:", error);
  }
};

export const fetchBankLeadData = async (id: string) => {
  try {
    if (id) {
      const docRef = doc(db, "bank_leads", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.error("No document found for ID:", id);
      }
    }
  } catch (error) {
    console.error("Error fetching bank lead data:", error);
  }
};

export const fetchSupplierData = async (id: string) => {
  try {
    if (id) {
      const supplierDocRef = doc(db, "suppliers", id);
      const docSnap = await getDoc(supplierDocRef);

      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.error("No document found for ID:", id);
      }
    }
  } catch (error) {
    console.error("Error fetching supplier data:", error);
  }
};

export const fetchAdminData = async (id: string) => {
  try {
    const q = query(collection(db, "admin"), where("id", "==", id));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const docRef = querySnapshot.docs[0];

      return docRef.data();
    } else {
      console.error("No document found for ID:", id);
      return null;
    }
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};

export const updateFirestoreDoc = async (
  db: Firestore,
  collection: string,
  docId: string,
  data: Record<string, any>
) => {
  await updateDoc(doc(db, collection, docId), {
    ...data,
  });
};

export const updateFirestoreSubDoc = async (
  db: Firestore,
  collection: string,
  docId: string,
  subCollection: string,
  subDocId: string,
  data: Record<string, any>
) => {
  await updateDoc(doc(db, collection, docId, subCollection, subDocId), {
    ...data,
    updatedAt: new Date().toISOString(),
  });
};

export const setFirestoreDoc = async (
  db: any,
  collectionName: string,
  docId: string,
  data: Record<string, any>,
  merge: boolean = true
) => {
  const docRef = doc(db, collectionName, docId);
  await setDoc(docRef, data, { merge });
};

export const setFirestoreSubDoc = async (
  db: any,
  collectionName: string,
  docId: string,
  subCollection: string,
  subDocId: string,
  data: Record<string, any>,
  merge: boolean = true
) => {
  const docRef = doc(db, collectionName, docId, subCollection, subDocId);
  await setDoc(docRef, data, { merge });
};

export const deleteFirestoreDoc = async (
  db: any,
  collectionName: string,
  docId: string
) => {
  const docRef = doc(db, collectionName, docId);
  await deleteDoc(docRef);
};
